import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";

import { cn } from "@/lib/cn";

import { NAV_ITEMS } from "./nav-items";

/** Mobile-only bottom tab bar (< lg). Desktop uses the sidebar. */
export function MobileTabBar() {
  const { t } = useTranslation();

  return (
    <nav className="pb-safe fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface lg:hidden">
      <ul
        className="grid"
        style={{ gridTemplateColumns: `repeat(${NAV_ITEMS.length}, minmax(0, 1fr))` }}
      >
        {NAV_ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center gap-1 px-1 py-2 text-[11px] transition-colors",
                  isActive ? "text-brand" : "text-muted",
                )
              }
            >
              <item.icon className="h-5 w-5" />
              <span className="w-full truncate text-center">{t(item.labelKey)}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
